import { useEffect, useState } from "react";

import './BrandLogos.scss'
import { HomeBrandBanner } from "../../../../types/HomeBrandBanner";
import { Brands } from "../../../../types/Brands";
interface BrandBannersProps {
  brands: Brands[];
  onRemove: (brand: Brands) => void;
  onUpdate: (brand: Brands) => void;
  updateBrand: (brand : Brands,image : File | null) => void;
}

export default function BrandLogos({ brands, onRemove, onUpdate, updateBrand }: BrandBannersProps) {
  //effects
  const [bannerImages, setBannerImages] = useState<Record<string, File>>({});

  //actions
  const handleImageUpload = (banner: HomeBrandBanner) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
  
    input.onchange = (e) => {
      const files = (e.target as HTMLInputElement).files;
      if (files && files.length > 0) {
        const file = files[0];
          setBannerImages(prev => ({ ...prev, [banner.id]: file }));
      }
    };
  
    input.click();
  };

  const save = (banner : HomeBrandBanner) => {
    updateBrand(banner,bannerImages[banner.id])
  }

  //Effects
  useEffect(() => {
    //avoid memory leaks
    return () => {
      Object.values(bannerImages).forEach(file => URL.revokeObjectURL(URL.createObjectURL(file)));
    };
  }, []);

  return (
    <div className="slider-wrap ">
      <div className="sliders-grid logo-wrap">
        {brands?.map((banner) =>{ 
           const bannerFile = bannerImages[banner?.id];
           const bannerPreview = bannerFile ? URL.createObjectURL(bannerFile) : banner?.imageUrl;
          return (
          <div key={banner?.id} className="slider-card">
            <div className="sliderActions">
                <button 
                className="save-btn"
                onClick={() => save(banner)}
              >
                Save
              </button>
              <button 
                className="remove-btn"
                onClick={() => onRemove(banner)}
              >
                ×
              </button>
            </div>
            {/* Image */}
            <div 
              className="image-upload desktop"
              onClick={() => handleImageUpload(banner)}
            >
              {bannerPreview ? (
                <>
                  <img src={bannerPreview} alt="Banner image" />
                  <span className="hover-text">Change banner image</span>
                </>
              ) : (
                <span>Upload banner image</span>
              )}
            </div>
            <input
              type="text"
              value={banner?.name || ''}
              onChange={(e) => onUpdate({...banner, name: e.target.value})}
              placeholder="Enter Brand Title"
              className="url-input"
              disabled={true}
            />
            
          </div>
        )})}
      </div>
    </div>
  );
}